import * as React from 'react';

var _circle, _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgFlow = function SvgFlow(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#00EF8B"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M69.36 50.64h16.92v16.92H69.36zM52.44 73.92c0 3.48-2.88 6.36-6.36 6.36s-6.36-2.88-6.36-6.36 2.88-6.36 6.36-6.36h6.36V50.64h-6.36c-12.84 0-23.28 10.44-23.28 23.28S33.24 97.2 46.08 97.2s23.28-10.44 23.28-23.28v-6.36H52.44zM75.72 42.12H94.8V25.2H75.72c-12.84 0-23.28 10.44-23.28 23.28v2.16h16.92v-2.16c0-3.48 2.88-6.36 6.36-6.36"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#16FF99",
        d: "M69.36 50.64H52.44v16.92h16.92z"
    })));
};

export { SvgFlow as ReactComponent };
//# sourceMappingURL=Flow.svg.es.js.map
